import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, Play } from "lucide-react";

export default function ContinueWatchingRow({ items }) {
  const ref = useRef(null);
  if (!items || items.length === 0) return null;
  const scroll = (dir) => ref.current?.scrollBy({ left: 600 * dir, behavior: "smooth" });
  return (
    <section className="relative mb-10 group/row" data-testid="row-continue-watching">
      <div className="flex items-center justify-between mb-3 px-6 lg:px-12">
        <h2 className="text-xl md:text-2xl font-semibold tracking-tight">Continue Watching</h2>
      </div>
      <div className="relative">
        <button onClick={() => scroll(-1)} className="absolute left-0 top-0 bottom-0 z-20 w-12 lg:w-20 bg-gradient-to-r from-[#0A0A0A] to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity flex items-center justify-center text-gray-400 hover:text-white">
          <ChevronLeft className="w-8 h-8" />
        </button>
        <div ref={ref} className="flex gap-3 overflow-x-auto scrollbar-hide snap-x snap-mandatory px-6 lg:px-12 pb-4">
          {items.map((v) => (
            <Link
              key={v.id}
              to={`/watch/${v.id}`}
              data-testid={`continue-${v.id}`}
              className="relative flex-shrink-0 snap-start group rounded-md overflow-hidden bg-[#121212] card-hover"
            >
              <div className="w-[280px] h-[160px] md:w-[320px] md:h-[180px] relative">
                <img src={v.backdrop} alt={v.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="bg-white/95 text-black p-4 rounded-full">
                    <Play className="w-8 h-8 fill-current" />
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <h4 className="text-white font-semibold text-sm line-clamp-1">{v.title}</h4>
                  <div className="mt-2 h-1 bg-white/20 rounded-full overflow-hidden">
                    <div className="h-full bg-[#E50914]" style={{ width: `${Math.min(100, v.progress?.percent || 0)}%` }} />
                  </div>
                  <p className="text-[11px] text-gray-400 mt-1">
                    {Math.floor((v.progress?.position_seconds || 0) / 60)} of {Math.floor((v.progress?.duration_seconds || 1) / 60)} min
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <button onClick={() => scroll(1)} className="absolute right-0 top-0 bottom-0 z-20 w-12 lg:w-20 bg-gradient-to-l from-[#0A0A0A] to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity flex items-center justify-center text-gray-400 hover:text-white">
          <ChevronRight className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
}
